<template>
    <b-container fluid>
        <hr/>
        <h3>{{name}}</h3>
        <hr/>
        <b-button @click="goBack">Back</b-button>
        <hr/>
        <v-skeleton-loader
                :loading="this.loadingIndex"
                transition='fade-transition'
                ref="skeleton"
                type="table"
                class="mx-auto"
                width="100%">
            <b-table striped :items="Configs" :fields="['config_name', 'manage']">
                <template slot="manage" slot-scope="data">
                    <b-button @click="openManager(data.item)" variant="primary">Manage</b-button>
                </template>
            </b-table>
        </v-skeleton-loader>

        <ManuallyChangeProjectConfig v-bind:projectConfig="projectConfig" v-bind:projectId="projectId"
                                     @saved-project-config="onUpdateConfig" @show-loading-pop-up="showLoadingPopUp"
                                     @reset-loading-pop-up="resetLoadingPopUp">
        </ManuallyChangeProjectConfig>
        <shopware-to-exact-manager v-bind:projectConfig="projectConfig" v-bind:projectId="projectId"
                                   @saved-project-config="onUpdateConfig" @show-loading-pop-up="showLoadingPopUp"
                                   @reset-loading-pop-up="resetLoadingPopUp">
        </shopware-to-exact-manager>
        <shopware6-to-exact-online v-bind:projectConfig="projectConfig" v-bind:projectId="projectId"
                                   @saved-project-config="onUpdateConfig" @show-loading-pop-up="showLoadingPopUp"
                                   @reset-loading-pop-up="resetLoadingPopUp">
        </shopware6-to-exact-online>
        <shopware-importer-manager v-bind:projectConfig="projectConfig" v-bind:projectId="projectId"
                                   @saved-project-config="onUpdateConfig" @show-loading-pop-up="showLoadingPopUp"
                                   @reset-loading-pop-up="resetLoadingPopUp">
        </shopware-importer-manager>
        <shopware6-importer-manager v-bind:projectConfig="projectConfig" v-bind:projectId="projectId"
                                    @saved-project-config="onUpdateConfig" @show-loading-pop-up="showLoadingPopUp"
                                    @reset-loading-pop-up="resetLoadingPopUp">
        </shopware6-importer-manager>
        <exact-online-manager v-bind:projectConfig="projectConfig" v-bind:projectId="projectId"
                              @saved-project-config="onUpdateConfig" @show-loading-pop-up="showLoadingPopUp"
                              @reset-loading-pop-up="resetLoadingPopUp">
        </exact-online-manager>
        <snel-start-v2 v-bind:projectConfig="projectConfig" v-bind:projectId="projectId"
                       @saved-project-config="onUpdateConfig" @show-loading-pop-up="showLoadingPopUp"
                       @reset-loading-pop-up="resetLoadingPopUp">
        </snel-start-v2>
        <!--        <exact-to-shopware-manager v-bind:projectConfig="projectConfig" v-bind:projectId="projectId"-->
        <!--                                   @saved-project-config="onUpdateConfig"@show-loading-pop-up="showLoadingPopUp" -->
        <!--                                   @reset-loading-pop-up="resetLoadingPopUp">-->
        <!--        </exact-to-shopware-manager>-->
    </b-container>
</template>

<script>
    import ProjectRepository from '../../repositories/project.repository';
    // Config managers
    import ExactToShopwareManager from './managers/ExactOnlineToShopware.vue';
    import ShopwareToExactManager from './managers/ShopwareToExactOnline.vue';
    import ManuallyChangeProjectConfig from './managers/ManuallyChangeProjectConfig.vue';
    import ShopwareImporterManager from "./managers/Shopware";
    import Shopware6ImporterManager from "./managers/Shopware6";
    import ExactOnlineManager from "./managers/ExactOnline";
    import Shopware6ToExactOnline from "./managers/Shopware6ToExactOnline";
    import SnelStartV2 from "./managers/SnelStart";

    export default {
        data() {
            return {
                name: 'Projectconfig manager',
                Configs: [
                    {
                        config_name: 'Manually change the config',
                        config_key: '',
                        modal_id: 'manual_config_manager_modal'
                    },
                    {
                        config_name: 'Shopware 5.6',
                        config_key: 'shopwareConfig',
                        modal_id: 'shopware_manager_modal'
                    },
                    {
                        config_name: 'Shopware 6',
                        config_key: 'shopware6Config',
                        modal_id: 'shopware6_manager_modal'
                    },
                    {
                        config_name: 'Exact Online v1',
                        config_key: 'ExactOnline1Config',
                        modal_id: 'exact_online_manager_modal'
                    },
                    // {config_name: 'Exact Online to shopware', config_key: 'ExactOnline1ToShopware5_6Config',modal_id: 'exact_to_shopware_manager_modal'},
                    {
                        config_name: 'Shopware 5.6 to Exact Online v1',
                        config_key: 'shopware5_6ToExactOnline1Config',
                        modal_id: 'shopware_to_exact_manager_modal'
                    },
                    {
                        config_name: 'Shopware 6 to Exact Online v1',
                        config_key: 'shopware6ToExactOnline1Config',
                        modal_id: 'shopware6_to_exact_manager_modal'
                    },
                    {
                        config_name: 'Shopware 6 to SnelStartV2',
                        config_key: 'SnelStartV2Config',
                        modal_id: 'snel_start_v2_manager_modal'
                    },
                ],
                projectConfig: {},
                projectId: -1,
                loadingIndex: false,
            }
        },
        components: {
            Shopware6ToExactOnline,
            ManuallyChangeProjectConfig,
            ExactToShopwareManager,
            ShopwareToExactManager,
            ShopwareImporterManager,
            Shopware6ImporterManager,
            ExactOnlineManager,
            SnelStartV2,
        },
        methods: {
            showLoadingPopUp(text) {
                this.$emit('show-loading-pop-up', text);
            },
            resetLoadingPopUp() {
                this.$emit('reset-loading-pop-up');
            },
            openManager(data) {
                this.$bvModal.show(data.modal_id);
            },
            onUpdateConfig() {
                this.$emit('show-loading-pop-up', 'Updating the config.');
                ProjectRepository.getProjectConfig(this.projectId).then(res => {
                    this.projectConfig = res.data.projectData.config;
                    this.$emit('reset-loading-pop-up');
                }).catch(error => {
                    this.$emit('reset-loading-pop-up');
                });
            },
            goBack() {
                this.$router.push({path: `/projects`});
            }
        },
        created() {
            this.loadingIndex = true;
            ProjectRepository.getProjectConfig(this.$route.params.id).then(res => {
                this.loadingIndex = false;
                this.projectId = res.data.projectData.id;
                this.name = 'Manage ' + res.data.projectData.name + '\'s projectconfig';
                this.projectConfig = res.data.projectData.config;
            }).catch(error => {
                this.loadingIndex = false
            });
        }
    }
</script>
